import { render, staticRenderFns } from "./MsComboBoxDropdown.vue?vue&type=template&id=f8bea6c0&scoped=true"
import script from "./MsComboBoxDropdown.vue?vue&type=script&lang=js"
export * from "./MsComboBoxDropdown.vue?vue&type=script&lang=js"
import style0 from "./MsComboBoxDropdown.vue?vue&type=style&index=0&id=f8bea6c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8bea6c0",
  null
  
)

export default component.exports